import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, BookOpen, Library, User } from 'lucide-react';

export const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const navItems = [
    { path: '/today', icon: Home, label: 'Dzisiaj' },
    { path: '/lessons', icon: BookOpen, label: 'Lekcje' },
    { path: '/library', icon: Library, label: 'Biblioteka' },
    { path: '/profile', icon: User, label: 'Profil' }
  ];

  const hiddenPaths = ['/', '/welcome', '/auth', '/admin', '/download', '/lesson/'];
  if (hiddenPaths.some(p => location.pathname.startsWith(p))) {
    return null;
  }

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-40"
      style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 48px)' }}
    >
      <nav 
        style={{ 
          background: 'rgba(10, 20, 35, 0.85)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          paddingBottom: 'max(env(safe-area-inset-bottom), 16px)' 
        }}
      >
        <div className="flex justify-around items-center h-16 max-w-lg mx-auto px-4">
          {navItems.map(({ path, icon: Icon, label }) => {
            const isActive = location.pathname === path || (path !== '/' && location.pathname.startsWith(path));
            return (
              <button
                key={path}
                onClick={() => navigate(path)}
                className={`relative flex flex-col items-center justify-center w-16 h-full transition-colors ${
                  isActive ? 'text-sky-400' : 'text-slate-500 hover:text-slate-300'
                }`}
                data-testid={`nav-${label.toLowerCase()}`}
              >
                {isActive && (
                  <span 
                    className="absolute top-0 w-8 h-0.5 rounded-full"
                    style={{ background: 'linear-gradient(90deg, #0ea5e9, #06b6d4)' }}
                  />
                )}
                <Icon className={`w-5 h-5 mb-1 ${isActive ? 'stroke-[2.5]' : ''}`} />
                <span className="text-xs font-medium">{label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
};
